import { z } from 'zod';
export const SearchSchema = z.object({
  /**
   * 比較対象のバージョン（Task ID）。列は新しい順に並べる。
   * 未指定なら現在のバージョンから数世代を既定で並べる。
   * 配列以外が渡された URL でもエラー画面に落とさず既定表示に戻す。
   */
  versionIds: z.array(z.string()).optional().catch(undefined)
});